export const defaultFilters = () => ({
    pagination: {
        limit: 20,
        page: 1,
    },
    filter: {
      createdAt: {
        value: '',
        operator: 'bwn'
      },
      advertisers: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      countries: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      partners: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      trafficSources: {
        id: {
          value: '',
          operator: 'in'
        }
      },
      stream: {
        siteId: {
          value: '',
          operator: 'like'
        }
      },
    },
    sortBy: ['id'],
    sortDesc: [true],
    clientOptions: {
        filterPanelExpanded: false,
    },
})
